import ProxyButton from '../../components/common/ProxyButton';
import {
  TOTP_PROVIDER_AMPLITUDE_EVENT
} from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { createWrapper } from '../../utils/react-utils';
import TotpAppsList from '../../components/enroll-totp/TotpAppsList';
import React from 'react';
import BaseForgeCustomizer from '../base-forge';
import MutedText from '../../components/common/MutedText';
import { getLocalizedString } from '../../utils/i18n-utils';

export default class BarcodeTotpCustomizer extends BaseForgeCustomizer {
  displayFooterText = true;
  headerText = getLocalizedString('totp.enroll.step.1.header.text');

  async shouldCustomize() {
    return [ 'barcode-totp' ].includes(this.context.controller);
  }

  forgifyController() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['GOOGLE']}TotpBarcodeScan::Landing`);
    this.oktaSignIn.router.appState.set('isManualTotpSetup', false);
    super.forgifyController();
    this.forgifyCantScanButton();
    this.forgifyRefreshCodeText();
    this.addScanQrCodeInstructions();
    this.hideScanInstructionsDetails();
    this.alterScanInstructionsQrCodeWrapper();
  }

  private hideScanInstructionsDetails() {
    const oktaScanInstructions: JQuery<HTMLElement> = jQueryCourage('.scan-instructions-details-wrapper');
    if (oktaScanInstructions.length > 0) {
      this.hideComponent(oktaScanInstructions[0]);
    }
  }

  private alterScanInstructionsQrCodeWrapper() {
    const oktaQrcodeWrapper: JQuery<HTMLElement> = jQueryCourage('.scan-instructions-qrcode-wrapper');
    if (oktaQrcodeWrapper.length > 0) {
      oktaQrcodeWrapper.css('float', 'none');
      const manualSetupLink: HTMLElement = oktaQrcodeWrapper[0].childNodes[1] as HTMLElement;
      if (manualSetupLink) {
        manualSetupLink.innerText = getLocalizedString('barcode.totp.cant.scan.text');
      }
    }
  }

  private addScanQrCodeInstructions() {
    const athenaOFormHeader: JQuery = jQueryCourage('.o-form-info-container');
    if (athenaOFormHeader.length > 0) {
      const totpAppsListContainer = createWrapper({ hidden: false });
      athenaOFormHeader.before(totpAppsListContainer);
      const component = (
        <div className={'fe_u_text-align--left fe_u_margin--bottom-large'}>
          <MutedText className={'fe_u_margin--bottom-small'} text={getLocalizedString('totp.enroll.step.1.header.description')} />
          <TotpAppsList />
        </div>
      );

      this.renderReactComponent({
        id: 'totp-apps-list',
        component,
        container: totpAppsListContainer,
      });
    }
  }

  protected forgifyCantScanButton() {
    const cantScanLink = jQueryCourage('.manual-setup');
    if (cantScanLink.length) {
      const forgeComponent = <ProxyButton oktaButton={cantScanLink} fullWidth variant="tertiary" />;
      this.renderForgeAndHideOktaComponent({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: cantScanLink.attr('class')!,
        oktaComponent: cantScanLink,
        forgeComponent: forgeComponent,
      });
    }
  }


  private forgifyRefreshCodeText() {
    const refreshQrCodeLink = jQueryCourage('.refresh-qrcode');
    if (refreshQrCodeLink.length) {
      const forgeComponent = <ProxyButton oktaButton={refreshQrCodeLink} variant="tertiary" fullWidth />;
      this.renderForgeAndHideOktaComponent({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: 'refresh-qrcode',
        className: 'refresh-qrcode',
        oktaComponent: refreshQrCodeLink,
        forgeComponent: forgeComponent,
      });
    }
  }
}
